/**
 * "지금 어느 단계인가" 를 문서가 물어볼 수 있게 하는 derive.
 *
 * 규칙 표(`counselStageMachine`)는 이 패키지에 있고, 술어 구현은 호스트마다 다르다 —
 * 프로덕션은 `VisitCounselView` 를, 프리뷰는 목 상담을 읽는다. 그래서 derive 자체를
 * 상수로 둘 수 없고, 술어를 받아 만드는 팩토리가 된다.
 *
 * 결과는 `spread: true` 로 스코프에 편다. 루트 문서의 `branch` 가 `stage`·`sub` 를
 * 자기 이름으로 읽기 때문이다.
 */
import { resolveStage, type PredicateRegistry } from "@miso/design-system";

import { counselStageMachine } from "../routes/counselStages";

/** 문서가 이 이름으로 부른다. */
export const COUNSEL_STAGE_DERIVE = "counsel.stage";

export function createStageDerive<TCounsel>(
  predicates: PredicateRegistry<TCounsel>,
): Record<string, (args: Record<string, unknown>) => unknown> {
  return {
    [COUNSEL_STAGE_DERIVE]: (args: Record<string, unknown>) => {
      const counsel = args.counsel as TCounsel | undefined;
      if (counsel === undefined || counsel === null) return { stage: "start" };
      const decision = resolveStage(counselStageMachine, counsel, predicates);
      return {
        stage: decision.stage,
        ...(decision.sub !== undefined ? { sub: decision.sub } : {}),
        ...(decision.target !== undefined ? { target: decision.target } : {}),
      };
    },
  };
}
